import { Stack } from '@mui/material';
import { ReactNode } from 'react';

import { INLINE_MD } from '@/styles/tokens/panelWidths';

export interface DiagramPanelLayoutProps {
  isPanelOpen: boolean;
  panelWidth?: number;
  gap?: number;
  height: number;
  width: number;
  children: ReactNode;
}

/**
 * Shared grid layout for diagram views with a collapsible inline side panel.
 * When the panel is open, the layout splits into `auto <panelWidth>px` columns.
 */
export function DiagramPanelLayout({
  isPanelOpen,
  panelWidth = INLINE_MD,
  gap = 2,
  height,
  width,
  children,
}: DiagramPanelLayoutProps) {
  return (
    <Stack
      display="grid"
      gridTemplateColumns={isPanelOpen ? `auto ${panelWidth}px` : 'auto'}
      gap={gap}
      height={height}
      width={width}
    >
      {children}
    </Stack>
  );
}
